import { fetch } from '@/utils/fetch';
import axios from 'axios';
import config from 'config';
import { getH5Platform, isIOS } from '@/utils/environment';
import { NativeService } from 'src/service/native/nativePluginService';

export const getRules = (params) => {
  return fetch({
    url: '/api/pcfp/step/rules',
    method: 'GET',
    params,
  });
};
//生成里程补贴
export const postCreateMile = (params) => {
  return fetch({
    url: '/api/pcfp/order',
    method: 'POST',
    data: params,
  });
};
// 同步轨迹点信息
export const updateTrackPoints = (params) => {
  return fetch({
    url: '/api/pcfp/track/point',
    method: 'GET',
    params,
    nativeResponseSerializer: 'boolean',
  });
};
// 获取行驶里程
export const getTrackPoint = (params) => {
  return fetch({
    url: '/api/pcfp/track/distance',
    method: 'GET',
    params,
    nativeResponseSerializer: 'number',
  });
};
//生成里程补贴费用
export const postMileAccount = (params) => {
  return fetch({
    url: '/api/v2/invoices',
    method: 'POST',
    data: params,
  });
};
//获取是否有设置单价
export const getPublic = () => {
  return fetch({
    url: '/api/private/car/for/public/my',
    method: 'GET',
  });
};
//删除里程
export const deleteMile = (id) => {
  return fetch({
    url: '/api/pcfp/delete/order',
    method: 'GET',
    params: { ids: id },
  });
};
//获取已经生成费用的里程补贴
export const getMileAccount = (date) => {
  return fetch({
    url: '/api/pcfp/invoice',
    method: 'GET',
    params: { date: date },
  });
};
//获取未生成费用的里程补贴
export const getNoMileAccount = (date, ruleId) => {
  return fetch({
    url: '/api/pcfp/invoice/data',
    method: 'GET',
    params: { date, ruleId },
  });
};
//获取里程补贴列表
export const getMileList = () => {
  return fetch({
    url: '/api/pcfp/user/order',
    method: 'GET',
  });
};
//获取已经成费用的提交
export const getAccountOrderList = (data) => {
  return fetch({
    url: '/api/pcfp/user/order',
    method: 'GET',
    params: data,
  });
};
//获取未成费用的提交
export const getNoAccountOrderList = (data) => {
  return fetch({
    url: '/api/pcfp/app/order',
    method: 'GET',
    params: data,
  });
};
// 通过id获取单笔里程
export const getMileDetail = (id) => {
  return fetch({
    url: `/api/pcfp/app/order/${id}`,
    method: 'GET',
  });
};

// 获取里程补贴模式
export const getMod = () => {
  return fetch({
    url: '/api/pcfp/mode',
    method: 'GET',
  });
};

// 获取里程补贴费用类型信息
export const getMileType = () => {
  return fetch({
    url: '/api/expense/types/supplierType/15',
    method: 'GET',
  });
};
// 阶梯计价保存费用 暂时用老接口
export const saveMileExpense = (data) => {
  return fetch({
    url: '/api/pcfp/invoice',
    method: 'POST',
    data,
  });
};

// 单价模式获取单价修改范围
export const getPriceRange = () => {
  return fetch({
    url: '/api/public/car/unit/price',
    method: 'GET',
  });
};
// 获取阶梯模式下策略
export const getStepDrivingPlanValue = () => {
  return fetch({
    url: '/api/pcfp/mystep',
    method: 'POST',
    data: {
      pageNo: 0,
      pageSize: 1,
    },
  });
};

// 其它坐标系转化成高德坐标系
export const convertLocationToAmap = (locations) => {
  let baseUrl = 'https://restapi.amap.com';
  if (['wx', 'dd', 'lark', 'yzj', 'welink'].includes(getH5Platform())) {
    baseUrl = '/amap';
  }
  return axios.get(
    `${baseUrl}/v3/assistant/coordinate/convert?locations=${locations}&key=174c8e2d376b5789cebbf78cd59f9e2f&coordsys=gps`
  );
};

//后端已经设置跨越
export const getLocationByAmap = (lnt, language, batch = false) => {
  let baseUrl = 'https://restapi.amap.com';
  if (['wx', 'dd', 'lark', 'yzj', 'welink'].includes(getH5Platform())) {
    baseUrl = '/amap';
  }

  let lan = 'ch';
  if (language) {
    lan = language;
  }
  return axios.get(
    `${baseUrl}/v3/geocode/regeo?location=${lnt}&key=174c8e2d376b5789cebbf78cd59f9e2f&language=${lan}&batch=${batch}`
  );
};

//后端已经设置跨越
export const getLocationByGoogleMap = (latitude, longitude) => {
  return axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBo7xCk36hTGgaIPLB85hKe5zTx6GQ8miE`
  );
};

/*
 * 开发文档https://lbs.amap.com/api/webservice/guide/api/direction，后面来调优
 * 高德距离最短模式，返回全部信息
 * 将strategy参数从2改成10
 * 算法2，距离优先，不考虑路况，仅走距离最短的路线，但是可能存在穿越小路/小区的情况
 * 算法10，返回结果会躲避拥堵，路程较短，尽量缩短时间，与高德地图的默认策略也就是不进行任何勾选一致
 */

export const getDrivingDirectionByAMap = (origin, destination, wayPoints, strategy = 10) => {
  let baseUrl = 'https://restapi.amap.com';
  if (['wx', 'dd', 'webapp', 'lark', 'yzj', 'welink'].includes(getH5Platform())) {
    baseUrl = '/amap';
  }

  return axios.get(
    baseUrl +
      '/v3/direction/driving?key=174c8e2d376b5789cebbf78cd59f9e2f&' +
      'origin=' +
      origin +
      '&destination=' +
      destination +
      '&originid=' +
      '&destinationid=&extensions=&strategy=' +
      strategy +
      '&waypoints=' +
      wayPoints +
      '&avoidpolygons=&avoidroad='
  );
};

//开发文档https://developers.google.com/maps/documentation/distance-matrix/intro?hl=zh-CN#DistanceMatrixRequests，后面来调优
//支持列表 https://developers.google.com/maps/coverage?hl=zh_cn#coverage-legend
//Google距离最短模式，返回全部信息
export const getDrivingDirectionByGoogle = (origin, destination) => {
  let url =
    'https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&' +
    'origins=' +
    origin +
    '&destinations=' +
    destination +
    '&' +
    'key=AIzaSyBo7xCk36hTGgaIPLB85hKe5zTx6GQ8miE';

  if (config.nativeBusinessFlag && isIOS()) {
    return NativeService().nativeHttpGoogleMap({
      url: url,
      method: 'GET',
    });
  } else {
    return axios.get(url);
  }
};

export const getDrivingByQQ = (begin, end, wayPoints, strategy = 10) => {
  let baseUrl = 'https://apis.map.qq.com';
  if (['wx', 'dd'].includes(getH5Platform())) {
    baseUrl = '';
  }

  return axios.get(
    `${baseUrl}/ws/direction/v1/driving/?from=${begin}&to=${end}&waypoints=${
      wayPoints || end
    }&key=E5XBZ-LWVWJ-2TUFJ-F73PP-VS5LS-W3FUM&output=json&policy=LEAST_DISTANCE`
  );
};

/**
 * @desc 判断里程模式当前是一月多次 或 一月一次
 * @returns {*}
 */
export const getMileRules = (data) => {
  return fetch({
    url: '/api/pcfp/detail',
    method: 'POST',
    data,
  });
};

/**
 * @desc 获取全部的里程 分页
 * @param params
 * @returns {*}
 */
export const getMileListPagination = (params) => {
  return fetch({
    url: '/api/pcfp/order',
    method: 'GET',
    params,
  });
};

/**
 * @desc 获取里程补贴详情
 * @param data
 * @returns {*}
 */
export const getMileageDetails = (data) => {
  return fetch({
    url: '/api/pcfp/detail',
    method: 'POST',
    data,
  });
};
/**
 * @desc 阶梯计价生成费用新接口
 * @param data
 * @returns {*}
 */
export const newMileExpense = (data) => {
  return fetch({
    url: '/api/pcfp/invoice/v2',
    method: 'POST',
    data,
  });
};
// 缓存里程信息
export const saveUnfinishedMile = (data) => {
  return fetch({
    url: '/api/pcfp/unfinished/order',
    method: 'POST',
    data,
  });
};
export const saveGuideData = (data) => {
  return fetch({
    url: '/api/pcfp/native/data',
    method: 'POST',
    data,
    nativeResponseSerializer: 'boolean',
  });
};
// 保存定位点
export const savePoint = (data) => {
  return fetch({
    url: '/api/pcfp/position/point',
    method: 'POST',
    data,
  });
};

export const updatePoint = (data) => {
  return fetch({
    url: '/api/pcfp/point',
    method: 'POST',
    data,
  });
};
export const deletePoint = (orderId, viaPointId) => {
  return fetch({
    url: `/api/pcfp/point?orderId=${orderId}&viaPointId=${viaPointId}`,
    method: 'DELETE',
  });
};
export const bindTrack = (data) => {
  return fetch({
    url: '/api/pcfp/bind/track',
    method: 'POST',
    data,
  });
};

export const getMileInfo = (params) => {
  return fetch({
    url: '/api/pcfp/mileage',
    method: 'GET',
    params,
  });
};

export const saveMile = (data) => {
  return fetch({
    url: '/api/pcfp/finish/order',
    method: 'POST',
    data,
  });
};
export const getTrackServiceStatus = () => {
  return fetch({
    url: '/api/pcfp/track/service/status',
    method: 'GET',
  });
};

export const getPriceRules = () => {
  return fetch({
    url: '/api/pcfp/unit/price/rule/list',
    method: 'GET',
  });
};

export const saveRemark = (data) => {
  return fetch({
    url: '/api/pcfp/add/remark',
    method: 'POST',
    data,
  });
};
